import * as React from "react";

const IconAtividades = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill={props.fill || "#7D8592"}
      d="M17.63.002c-3.513-.063-7.52 1.773-10.057 4.623a9.52 9.52 0 0 0-6.521 2.777.376.376 0 0 0 .21.638l2.89.414-.357.4a.375.375 0 0 0 .015.515l4.82 4.82a.374.374 0 0 0 .515.015l.4-.357.414 2.89c.02.142.131.245.266.29q.051.017.107.017a.42.42 0 0 0 .29-.121 9.5 9.5 0 0 0 2.753-6.498C16.227 7.883 18.08 3.877 17.997.368a.377.377 0 0 0-.366-.366m-3.455 6.474a1.87 1.87 0 0 1-1.326.548c-.481 0-.961-.183-1.326-.548a1.88 1.88 0 0 1 0-2.652 1.877 1.877 0 0 1 2.652 0 1.877 1.877 0 0 1 0 2.652M2.043 12.679c-.802.802-1.904 4.428-2.027 4.838a.376.376 0 0 0 .467.467c.41-.123 4.036-1.225 4.838-2.027a2.32 2.32 0 0 0 0-3.279 2.32 2.32 0 0 0-3.278 0"
    ></path>
  </svg>
);

export default IconAtividades;
